var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DashboardFilters',{ref:"generalFilter",attrs:{"isAdmin":_vm.isAdmin,"dashboardTab":_vm.dashboardTab,"enableFastFilters":true,"filterFor":"cards","generalFilters":true},on:{"filter":_vm.onFilterChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }